<template>
  <div>
    <c-card title="건강검진결과 엑셀업로드" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn 
            v-if="editable" 
            label="LBLAPPLY" 
            icon="save"
            @btnClicked="acceptData" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :editable="editable"
            :disabled="true"
            codeGroupCd="CHECK_UP_TYPE_CD"
            type="edit"
            itemText="codeName"
            itemValue="code"
            name="checkupTypeCd"
            label="건강검진 종류"
            v-model="popupParam.checkupTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-text
            :editable="editable"
            :disabled="true"
            label="요청부서/이름/일자"
            name="request"
            v-model="request">
          </c-text>
        </div>
      </template>
    </c-card>
    <c-excel-upload 
      :editable="editable"
      :excelUploadInfo="excelUploadInfo"
      :isCustomDown="true"
      :customFileInfo="fileInfo"
      :templateData="templateData"
      tabHeight="660px"
      gridHeight="630px"
    >
      <template v-slot:customBtn>
        <q-btn
          v-if="editable"  
          class="excel-upload-btn"
          icon="file_download"
          dense outline 
          size="sm"
          label="양식다운로드"
          @click="downTemplate">
        </q-btn>
      </template> 
    </c-excel-upload>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'checkup-result-excel-upload',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          plantCd: '',
          checkupTypeCd: null,
        }
      },
    },
  },
  data() {
    return {
      excelUploadInfo: {
        rowKeys: ['heaCheckupResultId'], // 데이터들의 키 속성값
        taskClassCd: '', // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [[]],
        data: [],
        deptCd: '',
        processCd: '',
        workplace: '',
      },
      changeItem: {
        plant: '',
        process: '',
        vendor: '',
      },
      fileInfo: {
        fileExt: '.xlsx',
        oriFileNm: '',
      },
      templateData: '',
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    request() {
      return this.$store.getters.user.deptName + ' / ' + this.$store.getters.user.userName + ' / '  + this.$comm.getToday()
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      if (this.popupParam.checkupTypeCd === 'CUTC000002') {
        this.excelUploadInfo.taskClassCd = 'HEA_RESULT_SPECIAL'
        this.$set(this.fileInfo, 'fileExt', '.xlsx');
        this.$set(this.fileInfo, 'oriFileNm', '특수건강검진 양식.xlsx');
        this.excelUploadInfo.columns[0] = [
          {
            disabled: true,
            name: 'userName',
            field: 'userName',
            label: '성명',
            align: 'center',
            style: 'width:100px',
          },
          {
            disabled: true,
            name: 'birthDate',
            field: 'birthDate',
            label: '생년월일',
            align: 'center',
            style: 'width:100px',
          },
          {
            disabled: true,
            name: 'checkupDate',
            field: 'checkupDate',
            label: '검진일자',
            align: 'center',
            style: 'width:120px',
          },
          {
            disabled: true,
            name: 'hazardNames',
            field: 'hazardNames',
            label: '취급물질',
            style: 'width:400px', 
            align: 'left',
          },                                       
          {
            disabled: true,
            name: 'judgmentNames',
            field: 'judgmentNames',
            label: '특수판정',
            style: 'width:250px', 
            align: 'left',
          },
          {
            disabled: true,
            name: 'diseaseNames',
            field: 'diseaseNames',
            label: '특수소견',
            style: 'width:500px', 
            align: 'left',
          },
          {
            disabled: true,
            name: 'specialMeasures',
            field: 'specialMeasures',
            label: '특수조치',
            style: 'width:300px', 
            align: 'left',
          },
          {
            disabled: true,
            name: 'specialSuitabilities',
            field: 'specialSuitabilities',
            label: '특수업무적합성',
            style: 'width:200px', 
            align: 'left',
          },
          {
            disabled: true,
            name: 'remarks',
            field: 'remarks',
            label: '비고',
            style: 'width:200px', 
            align: 'left',
          },
        ]
      } else {
        this.excelUploadInfo.taskClassCd = 'HEA_RESULT_NORMAL'
        this.$set(this.fileInfo, 'fileExt', '.xlsx');
        this.$set(this.fileInfo, 'oriFileNm', '일반건강검진 양식.xlsx');
        this.excelUploadInfo.columns[0] = [
          {
            disabled: true,
            name: 'userName',
            field: 'userName',
            label: '성명',
            align: 'center',
            style: 'width:100px',
          },
          {
            disabled: true,
            name: 'birthDate',
            field: 'birthDate',
            label: '생년월일',
            align: 'center',
            style: 'width:100px',
          },
          {
            disabled: true,
            name: 'checkupDate',
            field: 'checkupDate',
            label: '검진일자',
            align: 'center',
            style: 'width:120px',
          },                                       
          {
            disabled: true,
            name: 'judgmentNames',
            field: 'judgmentNames',
            label: '판정',
            style: 'width:250px', 
            align: 'left',
          },
          {
            disabled: true,
            name: 'diseaseNames',
            field: 'diseaseNames',
            label: '질환',
            style: 'width:500px', 
            align: 'left',
          },
          // {
          //   disabled: true,
          //   name: 'remarks',
          //   field: 'remarks',
          //   label: 'LBLREMARK',
          //   style: 'width:200px', 
          //   align: 'left',
          // },
        ]
      }
      this.setHeader();
      this.setTemplate();
    },
    setTemplate() {
      this.$http.url = this.$format(selectConfig.hea.checkup.result.excelUpload.url, this.excelUploadInfo.taskClassCd);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.templateData = this.$_.clone(_result.data);
      },);
    },
    setHeader() {
      this.$http.url = selectConfig.hea.examine.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        useFlag: 'Y',
        examineTypeCd: this.popupParam.checkupTypeCd === 'CUTC000002' ? 'CIT0000002' : 'CIT0000001'
      };
      this.$http.request((_result) => {
        let count = 0;
        this.$_.forEach(_result.data, _item => {
          this.excelUploadInfo.columns[0].push(
            {   
              disabled: true,
              name: 'examine' + ++count,
              field: 'examine' + count,
              key: _item.examineId,
              label: _item.examineName, 
              style: 'width:70px', 
              align: 'center', 
            },
          )
        })
      },);
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (!this.excelUploadInfo.data[0] || this.excelUploadInfo.data[0].length === 0) {
          dataCntCheck = false;
        }
        if (this.$_.findIndex(this.excelUploadInfo.data[0], (item) => { return item.error_message }) > -1) {
          errorDataCheck = true
        }
        if (!dataCntCheck) {
          window.getApp.$emit('ALERT', {
            title: 'LBLGUIDE', // 안내
            message: '업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.', // 업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.
            type: 'warning', // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit('CONFIRM', {
              title: 'LBLCONFIRM',
              message: '에러가 있는 데이터가 존재합니다.\n\r에러 있는 데이터를 제외한 나머지 데이터를 적용하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수  
              confirmCallback: () => {
                this.$emit('closePopup', this.excelUploadInfo.data[0]);
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          } else {
            this.$emit('closePopup', this.excelUploadInfo.data[0], this.excelUploadInfo.columns[0]);
          }
        }
      }
    },
    /* eslint-disable no-unused-vars */
    downTemplate() {
      let url = window.URL || window.webkitURL;
      let link = document.createElement('a');
      let blob = this.$comm.base64ToBlob(this.templateData, this.fileInfo.fileExt);
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, this.fileInfo.oriFileNm);
      } else {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.fileInfo.oriFileNm;
        link.click();
      }
    },
  }
};
</script>
